export const OfficeExchangeApplicationId = '00000002-0000-0ff1-ce00-000000000000';
export const OwaApplicationId = '9199bf20-a13f-4107-85dc-02114787ef48';
export const MsaTenantId = '9188040d-6c67-4c5b-b112-36a304b66dad';
